import { useRef } from 'react';

/**
 * Calculate a value once upon initial render using a factory function.
 *
 * Subsequent renders will all use the same value as the first render.
 *
 * @param factory
 * Factory that will be used to produce the value. Only called for the first
 * render.
 */
const useConstant = <T>(factory: () => T) => {
  const didRunRef = useRef(false);
  const valueRef = useRef<T>(null);
  if (!didRunRef.current) {
    didRunRef.current = true;
    valueRef.current = factory();
  }
  return valueRef.current;
};

export default useConstant;
